"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugAnalyticsTracker = exports.debugAddTracked = exports.track = void 0;
const events_1 = __importDefault(require("events"));
class TrackedEvents {
    constructor() {
        this._em = new events_1.default();
        this._events = [];
    }
    all() {
        return this._events;
    }
    add(event) {
        this._events.push(event);
        this._em.emit('event', event);
    }
    onEvent(listener) {
        this._em.on('event', listener);
        return () => this._em.off('event', listener);
    }
}
const track = (name, data) => {
    // @ts-ignore
    if (typeof analytics !== 'undefined') {
        // @ts-ignore
        analytics.track(name, data);
    }
    (0, exports.debugAddTracked)(name, data);
};
exports.track = track;
const debugAddTracked = (name, data, error) => {
    exports.debugAnalyticsTracker.add({ id: Math.random(), name, data, error });
};
exports.debugAddTracked = debugAddTracked;
exports.debugAnalyticsTracker = new TrackedEvents();
//# sourceMappingURL=analytics.js.map